module.exports = "/_next/static/images/c2056f04786321680a4a526da1495b57-phone-and-card@1x.png";